import * as dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function timeTo(input) {
  const now = dayjs();
  const until = dayjs(input);

  return now.to(until);
}

export function format(input, format) {
  if (!format) {
    format = 'DD/MMMM/YYYY';
  }
  const date = dayjs(input).format(format);
  return date;
}
